import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Services from "@/pages/services/page";
import About from "@/pages/about/page";
import Contact from "@/pages/contact/page";
import Portfolio from "@/pages/portfolio/page";
import PortfolioDetail from "@/pages/portfolio/detail/page";
import Projects from "@/pages/projects/page";
import ProjectDetail from "@/pages/projects/detail/page";

import Pricing from "@/pages/pricing/page";
import Login from "@/pages/auth/login/page";
import Register from "@/pages/auth/register/page";
import ForgotPassword from "@/pages/auth/forgot-password/page";
import ResetPassword from "@/pages/auth/reset-password/page";
import DashboardOverview from "@/pages/dashboard/overview/page";
import DashboardProjects from "@/pages/dashboard/projects/page";
import DashboardProjectDetail from "@/pages/dashboard/projects/detail/page";
import DashboardTickets from "@/pages/dashboard/tickets/page";
import DashboardBilling from "@/pages/dashboard/billing/page";
import DashboardProfile from "@/pages/dashboard/profile/page";
import AdminOverview from "@/pages/admin/overview/page";
import AdminClients from "@/pages/admin/clients/page";
import AdminProjects from "@/pages/admin/projects/page";
import AdminLeads from "@/pages/admin/leads/page";
import AdminInvoices from "@/pages/admin/invoices/page";
import AdminTeam from "@/pages/admin/team/page";
import AdminPortfolio from "@/pages/admin/portfolio/page";
import AdminTickets from "@/pages/admin/tickets/page";
import AdminSettings from "@/pages/admin/settings/page";
import ProtectedRoute from "@/layouts/ProtectedRoute";

const routes: RouteObject[] = [
  // Public
  { path: "/", element: <Home /> },
  { path: "/services", element: <Services /> },
  { path: "/about", element: <About /> },
  { path: "/contact", element: <Contact /> },
  { path: "/portfolio", element: <Portfolio /> },
  { path: "/portfolio/:id", element: <PortfolioDetail /> },
  { path: "/projects", element: <Projects /> },
  { path: "/projects/:id", element: <ProjectDetail /> },
  { path: "/pricing", element: <Pricing /> },

  // Auth
  { path: "/login", element: <Login /> },
  { path: "/register", element: <Register /> },
  { path: "/forgot-password", element: <ForgotPassword /> },
  { path: "/reset-password", element: <ResetPassword /> },

  // Client Dashboard
  {
    path: "/dashboard",
    element: <ProtectedRoute allowedRoles={["client", "staff", "admin"]}><DashboardOverview /></ProtectedRoute>,
  },
  {
    path: "/dashboard/projects",
    element: <ProtectedRoute allowedRoles={["client", "staff", "admin"]}><DashboardProjects /></ProtectedRoute>,
  },
  {
    path: "/dashboard/projects/:id",
    element: <ProtectedRoute allowedRoles={["client", "staff", "admin"]}><DashboardProjectDetail /></ProtectedRoute>,
  },
  {
    path: "/dashboard/tickets",
    element: <ProtectedRoute allowedRoles={["client", "staff", "admin"]}><DashboardTickets /></ProtectedRoute>,
  },
  {
    path: "/dashboard/billing",
    element: <ProtectedRoute allowedRoles={["client", "staff", "admin"]}><DashboardBilling /></ProtectedRoute>,
  },
  {
    path: "/dashboard/profile",
    element: <ProtectedRoute allowedRoles={["client", "staff", "admin"]}><DashboardProfile /></ProtectedRoute>,
  },

  // Admin Panel
  {
    path: "/admin",
    element: <ProtectedRoute allowedRoles={["admin", "staff"]}><AdminOverview /></ProtectedRoute>,
  },
  {
    path: "/admin/clients",
    element: <ProtectedRoute allowedRoles={["admin", "staff"]}><AdminClients /></ProtectedRoute>,
  },
  {
    path: "/admin/projects",
    element: <ProtectedRoute allowedRoles={["admin", "staff"]}><AdminProjects /></ProtectedRoute>,
  },
  {
    path: "/admin/tickets",
    element: <ProtectedRoute allowedRoles={["admin", "staff"]}><AdminTickets /></ProtectedRoute>,
  },
  {
    path: "/admin/leads",
    element: <ProtectedRoute allowedRoles={["admin", "staff"]}><AdminLeads /></ProtectedRoute>,
  },
  {
    path: "/admin/invoices",
    element: <ProtectedRoute allowedRoles={["admin", "staff"]}><AdminInvoices /></ProtectedRoute>,
  },
  {
    path: "/admin/team",
    element: <ProtectedRoute allowedRoles={["admin"]}><AdminTeam /></ProtectedRoute>,
  },
  {
    path: "/admin/portfolio",
    element: <ProtectedRoute allowedRoles={["admin", "staff"]}><AdminPortfolio /></ProtectedRoute>,
  },
  {
    path: "/admin/settings",
    element: <ProtectedRoute allowedRoles={["admin"]}><AdminSettings /></ProtectedRoute>,
  },

  { path: "*", element: <NotFound /> },
];

export default routes;
